import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material/material.module';
import { SharedModule } from '../shared/shared.module';
import { EligibilityDetailDialogComponent } from './components/eligibility-detail-dialog/eligibility-detail-dialog.component';
import { EligibilityStatusChipComponent } from './components/eligibility-status-chip/eligibility-status-chip.component';
import { PppShiftDetailDialogComponent } from './components/ppp-shift-detail-dialog/ppp-shift-detail-dialog.component';
import { PppSummaryCardComponent } from './components/ppp-summary-card/ppp-summary-card.component';
import { RuleResultRowComponent } from './components/rule-result-row/rule-result-row.component';
import { PppDriverEligibilityComponent } from './pages/ppp-driver-eligibility/ppp-driver-eligibility.component';
import { PppLoadBonusesComponent } from './pages/ppp-load-bonuses/ppp-load-bonuses.component';
import { PppOverviewComponent } from './pages/ppp-overview/ppp-overview.component';
import { PppProgramRulesComponent } from './pages/ppp-program-rules/ppp-program-rules.component';
import { CarrierReasonPipe } from './pipes/carrier-reason.pipe';
import { CentsToDollarsPipe } from './pipes/cents-to-dollars.pipe';
import { DriverRuleNamePipe } from './pipes/driver-rule-name.pipe';
import { PppShellComponent } from './ppp-shell/ppp-shell.component';
import { PreferredPartnerRoutingModule } from './preferred-partner-routing.module';

@NgModule({
  declarations: [
    PppShellComponent,
    PppOverviewComponent,
    PppDriverEligibilityComponent,
    PppLoadBonusesComponent,
    PppProgramRulesComponent,
    PppSummaryCardComponent,
    EligibilityStatusChipComponent,
    EligibilityDetailDialogComponent,
    PppShiftDetailDialogComponent,
    RuleResultRowComponent,
    CarrierReasonPipe,
    DriverRuleNamePipe,
    CentsToDollarsPipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    PreferredPartnerRoutingModule,
  ],
  exports: [PppSummaryCardComponent],
})
export class PreferredPartnerModule {}
